const state = {
  full_screen: false,
  RoleId:localStorage.RoleId,
  permission:[]
}

const mutations = {
  FULL_SCREEN_TOGGLE: (state, flag) => {
    state.full_screen = flag
  },
  RoleId: (state, flag) => {
    state.RoleId = flag
  },
  Permission: (state, val) => {
    state.permission = val
  }
}

const actions = {
  fullScreenToggle({ commit }) {
    let flag = !state.full_screen
    commit('FULL_SCREEN_TOGGLE', flag)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
